import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';

import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-openshift',
  templateUrl: './openshift.component.html',
  styleUrls: ['./openshift.component.css']
})
export class OpenshiftComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  shiftColl: any = [];

  shiftactivityform = new FormGroup({
    shiftactivityid: new FormControl(0),
    shiftid: new FormControl(null, Validators.required),
    shiftdate: new FormControl(null, Validators.required),
    openingamt: new FormControl(null, Validators.required),

  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "OpenShift";

  shiftactivityid: number = 0

  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute, private datePipe: DatePipe,
    private loginService: LoginDataService, private activeModal: NgbActiveModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.shiftactivityid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.shiftactivityform.reset();
      this.fnInitializeShiftactivity();


      this.fngetShift();


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.shiftactivityid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeShiftactivity() {
    this.shiftactivityform.setValue({

      shiftactivityid: 0,
      shiftid: null,
      shiftdate: new Date(),
      openingamt: null,
    })
  }

  //Get 
  fngetShift() {

    var data = {
      'shiftid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getShift(data)
      .subscribe(
        (res) => {
          this.shiftColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
fnResetValidation(){
 if( this.shiftactivityform.get('shiftid')){
   this.shiftactivityform.controls['shiftid'].setErrors(null);
 }
}

  //Save Btn Click
  fnSaveBtnClick() {


    try {
      this.submitted = true;
      this.successfully = false;
      this.fnResetValidation()
      //Validate
      if (this.shiftactivityform.valid) {
        //Check
        var data = {
          'shiftactivityid': 0,
          'shiftid': this.shiftactivityform.get('shiftid').value,
          'shiftdate': this.fnFormatDatetime(this.shiftactivityform.get('shiftdate').value),
          'openingamt': this.shiftactivityform.get('openingamt').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckShiftactivity(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;
            if (_checkresult === "done") {
            
                //Insert Department
                this.fnInsertShiftactivity(data);
            
            }
            else {
              if (_checkresult === "name") {
                this.shiftactivityform.controls['shiftid'].setErrors({ 'notfound': true });
              }
            
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertShiftactivity(data) {

    this.appService.fnInsertShiftactivity(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
    
          //this.emitData.emit(this.shiftactivityid);
          // this.activeModal.close(true);

          // this.toastr.success('', "The new Open Shift has been added successfully.Insert Successfully");

          // this.fnInsertActivityLog('INSERT', 0, data.shiftactivityid);

          this.emitData.emit("DONE");
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }





  private fnEditMode(deptBO) {
    deptBO.shiftdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.shiftdate));
    this.shiftactivityform.setValue({

      shiftactivityid: deptBO.brandid,
      shiftid: deptBO.shiftid,
      shiftdate: deptBO.shiftdate,
      openingamt: deptBO.openingamt,

    });


    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
